import { fromJS } from 'immutable';
import { ACTIVE } from '../../utils/static-configuration';

import {
  LOAD_CAMPAIGNS_SUCCESS,
  LOAD_CAMPAIGNS_ERROR,
  LOAD_CAMPAIGNS,
  SET_CAMPAIGN_PERMISSION,
  UPDATE_PERMISSION,
  UPDATE_SHOW_CAMPAIGNS_LIST,
} from './constants';

const initialState = fromJS({
  campaigns: {},
  showCampaignsList: ACTIVE,
  loading: false,
  campaignsLoadError: null,
  campaignsLoading: false,
});

function campaignsListReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_CAMPAIGNS:
    return state
      .set('loading', true)
      .set('campaignsLoadError', null)
      .set('campaignsLoading', true);
  case LOAD_CAMPAIGNS_SUCCESS:
    return state
      .set('campaigns', action.campaigns)
      .set('loading', false)
      .set('campaignsLoadError', null)
      .set('campaignsLoading', false);
  case LOAD_CAMPAIGNS_ERROR:
    return state
      .set('campaignsLoadError', action.error)
      .set('loading', false)
      .set('campaignsLoading', false);
  case UPDATE_SHOW_CAMPAIGNS_LIST:
    return state.set('showCampaignsList', action.campaignPermissionStatus);
  case UPDATE_PERMISSION:
    return state.setIn(
      ['campaigns', action.campaignId, 'status'],
      action.status,
    );
  case SET_CAMPAIGN_PERMISSION: {
    const permission = fromJS(action.campaignPermission);
    return state.set(
      'campaigns',
      state
        .get('campaigns')
        .set(permission.getIn(['campaign', 'id']), permission),
    );
  }
  default:
    return state;
  }
}

export default campaignsListReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/influencers-campaign-list/reducer.js
 **/